<template>
	<div>
		<b-card class="p-5 mr-1" no-body>
			<b-row class="mb-1">
				<b-col class="d-flex justify-content-end">
					<b-button class="d-inline text-nowrap" variant="outline-primary" @click="openCreateModal()">
						<FeatherIcon icon="PlusIcon" size="20" />
					</b-button>
				</b-col>
			</b-row>
			<b-overlay :show="isLoading">
				<b-row class="mb-1 justify-content-end">
					<b-col cols="12" xl="5">
						<b-input-group id="cintillo-ala-input-group">
							<b-form-input
								v-model="search"
								class="d-inline-block"
								placeholder="Buscar código"
								@keyup.enter="handleInputSearch"
							/>
							<b-input-group-append>
								<b-button variant="outline-primary" @click="handleInputSearch()">
									<feather-icon class="cursor-pointer" icon="SearchIcon" />
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-col>
				</b-row>
				<b-table-simple responsive sticky-header="60vh" no-border-collapse>
					<b-thead class="sticky-header" style="white-space: nowrap">
						<b-tr>
							<b-th v-for="field in fields" :key="field.key" :class="field.class">
								{{ field.label }}
							</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<template v-if="knifeCodes.length > 0">
							<b-tr v-for="(knifeCode, index) in knifeCodes" :key="index">
								<b-td class="text-center">
									{{ knifeCode.code }}
								</b-td>
								<b-td class="text-center">
									{{ knifeCode.comment || "-" }}
								</b-td>
								<b-td class="text-center cursor-pointer" @click="openSerieListModal(knifeCode)">
									<b-button variant="flat-info">
										{{ knifeCode.knives_count }}
									</b-button>
								</b-td>
								<b-td class="text-center">
									<div>
										{{ knifeCode.created_by || "-" }}
									</div>
									<div v-if="knifeCode.created_at">
										{{ knifeCode.created_at | myGlobalDayWithHour }}
									</div>
								</b-td>
								<b-td class="text-center">
									<div>
										{{ knifeCode.updated_by || "-" }}
									</div>
									<div v-if="knifeCode.updated_at">
										{{ knifeCode.updated_at | myGlobalDayWithHour }}
									</div>
								</b-td>
								<b-td class="text-center">
									<b-button variant="flat-primary" @click="openUpdateDescription(knifeCode)">
										<feather-icon icon="EditIcon" />
									</b-button>
								</b-td>
							</b-tr>
						</template>
						<b-tr v-if="knifeCodes.length === 0">
							<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-overlay>
		</b-card>
		<CreateKnivesModal v-if="showCreateModal" @close="showCreateModal = false" @refresh="refresh" />
		<UpdateDescriptionModal
			v-if="showUpdateDescriptionModal"
			:knife="selectedKnife"
			@refresh="refresh"
			@close="showUpdateDescriptionModal = false"
		/>
		<SerieListModal v-if="showSerieListModal" :code="selectedCode" @close="showSerieListModal = false" />
	</div>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"
import CreateKnivesModal from "@/views/brain/tournament/views/knives/components/CreateKnivesModal.vue"
import UpdateDescriptionModal from "@/views/brain/tournament/views/knives/components/UpdateDescriptionModal.vue"
import SerieListModal from "@/views/brain/tournament/views/knives/components/SerieListModal.vue"
export default {
	name: "BrainTournamentKnives",
	components: { CreateKnivesModal, UpdateDescriptionModal, SerieListModal },
	data: () => ({
		showKnifeHistoryModal: false,
		search: "",
		isLoading: false,
		fields: [
			{ key: "code", label: "CÓDIGO", class: "text-center" },
			{ key: "description", label: "DESCRIPCIÓN", class: "text-center" },
			{ key: "quantity", label: "CANTIDAD", class: "text-center" },
			{ key: "created_at", label: "CREADO POR", class: "text-center" },
			{ key: "updated_at", label: "ACTUALIZADO POR", class: "text-center" },
			{ key: "action", label: "ACCIONES", class: "text-center" },
		],
		code: null,
		selectedKnife: null,
		knifeCodes: [],
		selectedCode: null,
		showCreateModal: false,
		showUpdateDescriptionModal: false,
		showSerieListModal: false,
	}),
	computed: {},
	mounted() {
		this.getKnifeCodes()
	},
	methods: {
		openSerieListModal(code) {
			this.selectedCode = code
			this.showSerieListModal = true
		},
		async updateKnife(knife) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${knife.status ? "activar" : "desactivar"} a ${knife.code}-${
					knife.series
				}?`,
				text: "",
			})
			if (!isConfirmed) {
				knife.status = !knife.status
				return
			}
			const { message } = await TournamentKnivesService.updateStatus(knife.id, {
				status: knife.status ? "Active" : "Inactive",
			})
			this.showSuccessToast(message)
			this.getKnifeCodes()
		},
		openUpdateDescription(knive) {
			this.selectedKnife = knive
			this.showUpdateDescriptionModal = true
		},
		async openCreateModal() {
			this.showCreateModal = true
		},
		handleInputSearch() {
			this.getKnifeCodes()
		},
		refresh() {
			this.getKnifeCodes()
		},
		async getKnifeCodes(page = 1) {
			try {
				this.isLoading = true
				const { data } = await TournamentKnivesService.getCodesList()
				this.knifeCodes = data || []
			} catch (error) {
				console.error(`Error fetching knife codes:`, error)
			} finally {
				this.isLoading = false
			}
		},
	},
}
</script>
<style scoped></style>
